<template>
  <div>

    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control"
               @keypress.enter="find()"
               v-model="query.generic"
               placeholder="Pesquisar por assunto ou usuário">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button class="col-md-1 ml-2 btn-sm btn-outline"
              :class="{ 'btn-outline-active': showFilter }"
              @click="showFilter = !showFilter">
        Filtros
      </button>

      <a v-if="hasFilter" @click="clearQueryAndFind()" href="#" class="nowrap">remover filtros</a>
    </div>

    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="event-important">Tipo de data</label>
          <select v-model="query.periodType" id="event-important" class="form-control">
            <option value="sent_at">Enviado em</option>
            <option value="opened_at">Aberto em</option>
            <option value="clicked_at">Clicado em</option>
          </select>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12 mt-4 pt-2 text-right">
          <button @click="clearQueryAndFind()" class="btn btn-sm btn-outline mr-2">Limpar filtros</button>
          <button @click="find()" class="btn btn-sm btn-primary">Aplicar</button>
        </div>
      </div>
    </template>
    <hr>

    <div class="row">
      <div class="col-sm-12">

        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>

        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th class="nowrap">ID</th>
              <th class="nowrap">User ID</th>
              <th class="nowrap">Para</th>
              <th class="nowrap">Assunto</th>
              <th class="nowrap">Enviado em</th>
              <th class="nowrap">Aberto em</th>
              <th class="nowrap">Clicado em</th>
              <th class="nowrap">Mailer (action)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="email in emails" :key="email.id">
              <td>{{ email.id }}</td>
              <td>{{ email.userId }}</td>
              <td>{{ email.to }}</td>
              <td>{{ email.subject }}</td>
              <td>{{ email.sentAt | datetime }}</td>
              <td>{{ email.openedAt | datetime }}</td>
              <td>{{ email.clickedAt | datetime }}</td>
              <td>{{ email.mailer }}</td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import { SearchIcon } from 'vue-feather-icons'

  export default {
    components: { Pagination, SearchIcon },
    computed: {
      emails() {
        return this.models
      }
    },
    created() {
      this.$set(this.query, 'periodType', 'sent_at')
      this.addOrderBy('sentAt', 'desc')

      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })
    },
    data() {
      return {
        modelPathPrefix: 'admin',
        nameModel: 'Email',
        showFilter: false
      }
    },
    methods: {
      find() {
        this.asyncTemplateSelect()
      }
    },
    mixins: [ModelMapper],
    name: 'Email'
  }
</script>

<style scoped>

</style>